
import React from 'react';

const PriorityGroup = ({ tickets, sortBy }) => {
  const priorityKeys = Object.keys(tickets);
  const sortedPriorities = sortBy === 'priority'
    ? priorityKeys.map(Number).sort((a, b) => b - a) 
    : priorityKeys; 

  return (
    <div className="kanban-board">
      {sortedPriorities.map((priority) => (
        <div key={priority} >
          <div className='col-title'>
            <h3>{`Priority Level ${priority}`}</h3>
          <div className='fix'>
            <img src="./images/3 dot menu.svg" alt="" width={20}/>
            <img src="./images/add.svg" alt="" width={20} />
          </div>
          </div>
          
          {tickets[priority].map((ticket) => (
            <div key={ticket.id} className="ticket kanban-column">
              <p>{ticket.id}</p>
              <div className='fix'>
                <img src={`./images/${ticket.status}.svg`} alt=""/>
                <h3>{ticket.title}</h3>
              </div>
              <div className='fix'>
                 <img src={`./images/${ticket.priority}.svg`} alt=""/>
              <p>{ticket.tag.join(', ')}</p>
              </div>
              
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PriorityGroup;
